import { IItemResponseWithSuccess } from '@common/api.models';
import { envConfigs } from '@config/envConfigs';
import { IPagedResultsV1 } from '@gcl/react-core';
import { apiServerGet, apiServerPost, apiServerPut } from '@common/axios.services';
import { IProjectRequest, IProjectRequestSearchFilter, IUpsertProjectRequestRequest } from './projectRequest.models';
import { IProjectRequestCompany } from './projectRequestCompany/projectRequestCompany.models';
import { IProjectRequestTeam } from './projectRequestTeam/projectRequestTeam.models';
import { IProjectRequestUser } from './projectRequestUser/projectRequestUser.models';

export const apiRoutes = {
  projectRequests: '/ProjectRequests',
  projectRequestsSearch: '/ProjectRequests/Search',
  projectRequestsDefaultCompanies: '/ProjectRequests/DefaultCompanies',

  saveProjectRequestAsDraft: '/ProjectRequests/Draft',
  requestProjectRequestEndorsement: '/ProjectRequests/RequestEndorsement',
  endorseAndSubmitProjectRequest: (id: number) => `/ProjectRequests/${id}/EndorseAndSubmit`,
  approveProjectRequestAndCreateProject: (id: number) => `/ProjectRequests/${id}/ApproveAndCreateProject`,
  getProjectRequestCompanies: (id: number) => `/ProjectRequests/${id}/Companies`,
  getProjectRequestTeams: (id: number) => `/ProjectRequests/${id}/Teams`,
  getProjectRequestUsers: (id: number) => `/ProjectRequests/${id}/Users`,
};

export const getProjectRequestsSearchAsync = async (
  props: IProjectRequestSearchFilter,
): Promise<IPagedResultsV1<IProjectRequest>> => {
  const result = await apiServerPost<IPagedResultsV1<IProjectRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectRequestsSearch}`,
    props,
  );
  return result.data;
};

export const getProjectRequestsDetailAsync = async (id: number): Promise<IItemResponseWithSuccess<IProjectRequest>> => {
  const result = await apiServerGet<IItemResponseWithSuccess<IProjectRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectRequests}/${id}`,
  );
  return result.data;
};
export const getProjectRequestCompaniesAsync = async (
  projectRequestId: number,
): Promise<IPagedResultsV1<IProjectRequestCompany>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectRequestCompany>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectRequestCompanies(projectRequestId)}`,
  );
  return result.data;
};

export const getProjectRequestTeamsAsync = async (
  projectRequestId: number,
): Promise<IPagedResultsV1<IProjectRequestTeam>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectRequestTeam>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectRequestTeams(projectRequestId)}`,
  );
  return result.data;
};

export const getProjectRequestUsersAsync = async (
  projectRequestId: number,
): Promise<IPagedResultsV1<IProjectRequestUser>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectRequestUser>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectRequestUsers(projectRequestId)}`,
  );
  return result.data;
};

export const getProjectRequestDefaultCompaniesAsync = async (): Promise<IPagedResultsV1<IProjectRequestCompany>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectRequestCompany>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectRequestsDefaultCompanies}`,
  );
  return result.data;
};

export const saveProjectRequestAsDraftAsync = async (
  request: IUpsertProjectRequestRequest,
): Promise<IItemResponseWithSuccess<IProjectRequest>> => {
  const result = await apiServerPost<IItemResponseWithSuccess<IProjectRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.saveProjectRequestAsDraft}`,
    request,
  );
  return result.data;
};

export const requestProjectRequestEndorsementAsync = async (
  request: IUpsertProjectRequestRequest,
): Promise<IItemResponseWithSuccess<IProjectRequest>> => {
  const result = await apiServerPost<IItemResponseWithSuccess<IProjectRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.requestProjectRequestEndorsement}`,
    request,
  );
  return result.data;
};

export const endorseAndSubmitProjectRequestAsync = async (
  request: IUpsertProjectRequestRequest,
): Promise<IItemResponseWithSuccess<IProjectRequest>> => {
  const result = await apiServerPut<IItemResponseWithSuccess<IProjectRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.endorseAndSubmitProjectRequest(request.id ?? 0)}`,
    request,
  );
  return result.data;
};

export const approveProjectRequestAndCreateProjectAsync = async (
  request: IUpsertProjectRequestRequest,
): Promise<IItemResponseWithSuccess<IProjectRequest>> => {
  const result = await apiServerPut<IItemResponseWithSuccess<IProjectRequest>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.approveProjectRequestAndCreateProject(request.id ?? 0)}`,
    request,
  );
  return result.data;
};
